import { getValueAndUnit, rem } from 'polished';

import clamp from '../number/clamp';

import getPxValue from './getPxValue';

/**
 * Attempts to subtract value with unit (ex. `2rem`) by given amount
 *
 * If it fails to calculate it because unit was in `%` or similar, then it will return the original value
 *
 * @note
 * The result format is implicit, so if you have `px` in input result will be in px,
 * and if you give value in rem result will also be in rem unit
 */
const subtractUnit = (
  valueWithUnit: string | undefined,
  amount: number | string,
  minValue: number = 0,
): string | undefined => {
  if (!valueWithUnit) return undefined;

  const amountPx = getPxValue(amount);

  if (!amountPx || amountPx <= 0) {
    return valueWithUnit;
  }

  const unit = getValueAndUnit(valueWithUnit)[1];

  const valuePx = getPxValue(valueWithUnit);

  if (typeof valuePx !== 'number') {
    return valueWithUnit;
  }

  const subtractedValuePx = clamp(valuePx - amountPx, minValue);

  return unit === 'rem' ? rem(subtractedValuePx) : `${subtractedValuePx}px`;
};

export default subtractUnit;
